import React from 'react'
import {StandardLayout} from 'common/layouts/StandardLayout'
import {TourismEmbedConfiguratorContainer} from './TourismEmbedConfigurator'
import {Provider} from 'react-redux'
import {initStore} from './redux/initStore'

const store = initStore()

export class TourismEmbedConfiguratorApp extends React.PureComponent {
  render () {
    const params = this.props.location.query
    return (
      <Provider store={store}>
        <StandardLayout>
          <TourismEmbedConfiguratorContainer {...params} />
        </StandardLayout>
      </Provider>
    )
  }
}
